var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('cursor-fx',{attrs:{"color":"#f9b535","color-hover":"#000000","outside-size":"150px","inside-size":"10px"}}),_c('Main')],1)}
var staticRenderFns = []

export { render, staticRenderFns }